<template>
	<q-page-container>
		<transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
			<router-view />
		</transition>
	</q-page-container>
</template>

<script lang="ts">
import Vue from 'vue';

export default class LayoutPageContainer extends Vue {

}
</script>

<style scoped>
	.animated {
		-webkit-animation-duration: .333s !important;
		animation-duration: .333s !important;
	}
</style>